import { render, staticRenderFns } from "./Branch.vue?vue&type=template&id=83b3ddda"
import script from "./Branch.vue?vue&type=script&lang=js"
export * from "./Branch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83b3ddda')) {
      api.createRecord('83b3ddda', component.options)
    } else {
      api.reload('83b3ddda', component.options)
    }
    module.hot.accept("./Branch.vue?vue&type=template&id=83b3ddda", function () {
      api.rerender('83b3ddda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/Branch.vue"
export default component.exports